import { render, staticRenderFns } from "./PageTabMenu.vue?vue&type=template&id=122a9c23&scoped=true"
import script from "./PageTabMenu.vue?vue&type=script&lang=js"
export * from "./PageTabMenu.vue?vue&type=script&lang=js"
import style0 from "./PageTabMenu.vue?vue&type=style&index=0&id=122a9c23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a9c23",
  null
  
)

export default component.exports